/**
 * Campos comuns a um vínculo temporal: início, fim (aberto = atual) e uma observação
 * livre. Usado nas correlações pessoa↔pessoa e pessoa↔empresa — um casamento entre
 * 2010 e 2012, uma sociedade que ainda vale, uma amizade com um contexto anotado.
 */
import { Input } from '@/components/ui/input';

export function CamposVinculo({
  inicio,
  fim,
  observacoes,
  onInicio,
  onFim,
  onObservacoes,
}: {
  inicio: string;
  fim: string;
  observacoes: string;
  onInicio: (v: string) => void;
  onFim: (v: string) => void;
  onObservacoes: (v: string) => void;
}) {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap gap-3">
        <label className="flex flex-1 flex-col gap-2">
          <span className="tipo-rotulo">Início</span>
          <Input type="date" value={inicio} onChange={(e) => onInicio(e.target.value)} />
        </label>
        <label className="flex flex-1 flex-col gap-2">
          <span className="tipo-rotulo">Fim (vazio = atual)</span>
          <Input type="date" value={fim} onChange={(e) => onFim(e.target.value)} />
        </label>
      </div>
      <label className="flex flex-col gap-2">
        <span className="tipo-rotulo">Observação</span>
        <Input
          value={observacoes}
          onChange={(e) => onObservacoes(e.target.value)}
          placeholder="Contexto do vínculo (opcional)"
        />
      </label>
    </div>
  );
}

/** Formata o período de um vínculo para exibição: "desde 2010" · "2010–2012" · "atual". */
export function periodoLegivel(inicio?: string | null, fim?: string | null): string {
  const ano = (d?: string | null) => (d ? d.slice(0, 4) : '');
  const i = ano(inicio);
  const f = ano(fim);
  if (i && f) return `${i}–${f}`;
  if (i) return `desde ${i}`;
  if (f) return `até ${f}`;
  return 'atual';
}
